// Core imports
import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';

// Component imports
import { Col, Menu } from 'antd';
import { User, Filter, EditSquare, Heart } from 'react-iconly';

// Misc imports
import { PREVIEW_MODES, NAV_NDES_CREATE, NAV_NDES_EDIT, NAV_NDES_VIEW, NAV_RELATIVE_NDES_ADVANCED_DETAILS, NAV_RELATIVE_NDES_BASIC_DETAILS, NAV_RELATIVE_NDES_DEATH_DETAILS, NAV_RELATIVE_NDES_PERSONAL_DETAILS } from '../../constants';
import replaceUrlParams from '../../utils/misc/replaceUrlParams';
import menuImg from '../../assets/images/menu-img.png';

// Constant declarations
const menuIconClass = 'remix-icon mr-8';

const NdeMenu = ({ title, subtitle, ndeUuid, ndeId, mode, onCloseDrawer, showFooterImage }) => {
  const location = useLocation();
  const { pathname } = location;

  const getNavPrefix = (mode) => {
    switch (mode) {
      case PREVIEW_MODES.CREATE:
        return NAV_NDES_CREATE;
      case PREVIEW_MODES.EDIT:
        return NAV_NDES_EDIT;
      case PREVIEW_MODES.VIEW:
        return NAV_NDES_VIEW;
      default:
        return ''; // Default case or error handling as needed
    }
  };

  const navPrefix = getNavPrefix(mode);

  const NAV_BASIC_DETAILS = navPrefix + NAV_RELATIVE_NDES_BASIC_DETAILS;
  const NAV_DEATH_DETAILS = navPrefix + NAV_RELATIVE_NDES_DEATH_DETAILS;
  const NAV_ADVANCED_DETAILS = navPrefix + NAV_RELATIVE_NDES_ADVANCED_DETAILS;
  const NAV_PERSONAL_DETAILS = navPrefix + NAV_RELATIVE_NDES_PERSONAL_DETAILS;

  // TODO: email should be fetched from the user's profile

  return (
    <Col flex="240px" className="nde-menu py-8">
      <div className="w-100">
        <div className="nde-menu-header mt-md-16 text-center">
          <h3 className="mt-24 mb-4">
            {title}
          </h3>
          <span className="p1-body">
            {subtitle}
          </span>
        </div>

        <Menu
          mode="inline"
          className="w-100 nde-menu-body"
          theme="light"
          selectedKeys={[pathname]}
        >
          <Menu.Item
            key={replaceUrlParams(NAV_BASIC_DETAILS, {...ndeUuid ? {ndeUuid} : {ndeId}})}
            icon={<EditSquare set="curved" className={menuIconClass} />}
            onClick={onCloseDrawer}
          >
            <Link to={replaceUrlParams(NAV_BASIC_DETAILS, {...ndeUuid ? {ndeUuid} : {ndeId}})}>
              Intro
            </Link>
          </Menu.Item>

          <Menu.Item
            key={replaceUrlParams(NAV_DEATH_DETAILS, {...ndeUuid ? {ndeUuid} : {ndeId}})}
            icon={<Heart set="curved" className={menuIconClass} />}
            onClick={onCloseDrawer}
          >
            <Link to={replaceUrlParams(NAV_DEATH_DETAILS, {...ndeUuid ? {ndeUuid} : {ndeId}})}>
              Experience
            </Link>
          </Menu.Item>

          <Menu.Item
            key={replaceUrlParams(NAV_ADVANCED_DETAILS, {...ndeUuid ? {ndeUuid} : {ndeId}})}
            icon={<Filter set="curved" className={menuIconClass} />}
            onClick={onCloseDrawer}
          >
            <Link to={replaceUrlParams(NAV_ADVANCED_DETAILS, {...ndeUuid ? {ndeUuid} : {ndeId}})}>
              Details
            </Link>
          </Menu.Item>

          <Menu.Item
            key={replaceUrlParams(NAV_PERSONAL_DETAILS, {...ndeUuid ? {ndeUuid} : {ndeId}})}
            icon={<User set="curved" className={menuIconClass} />}
            onClick={onCloseDrawer}
          >
            <Link to={replaceUrlParams(NAV_PERSONAL_DETAILS, {...ndeUuid ? {ndeUuid} : {ndeId}})}>
              Contact
            </Link>
          </Menu.Item>
        </Menu>

      </div>

      {
        showFooterImage ? (
          <div className="nde-menu-footer">
            <img src={menuImg} alt="" className="px-16" />
          </div>
        ) : null
      }
    </Col>
  );
};

NdeMenu.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  ndeUuid: PropTypes.string,
  ndeId: PropTypes.string,
  mode: PropTypes.string,
  showFooterImage: PropTypes.bool,
  onCloseDrawer: PropTypes.func
};

export default NdeMenu;
